import { render, staticRenderFns } from "./DraftToolbar.vue?vue&type=template&id=8f6542ee&scoped=true"
import script from "./DraftToolbar.vue?vue&type=script&lang=js"
export * from "./DraftToolbar.vue?vue&type=script&lang=js"
import style0 from "./DraftToolbar.vue?vue&type=style&index=0&id=8f6542ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6542ee",
  null
  
)

export default component.exports